import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function SuccessModal(props) {
  const { message } = props;
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Teşekkürler
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Dönüşleriniz gonderildi</h4>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Tamam</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SuccessModal;

/* function App() {
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <>
      <Button variant="primary" onClick={() => setModalShow(true)}>
        Launch vertically centered modal
      </Button>

      <SuccessModal show={modalShow} onHide={() => setModalShow(false)} />
    </>
  );
}
 */
